export enum DefenceType {
  All = "All",
  Armour = "Arm",
  Evasion = "Eva",
  EnergyShield = "ES",
  ArmourEvasion = "Arm/Eva",
  ArmourEnergyShield = "Arm/ES",
  EvasionEnergyShield = "Eva/ES",
}

export enum IdentifiedModTier {
  Excellent = 'Excellent',
  Good = 'Good',
  SingleMod = 'Single Mod',
  NonSelected = 'Non Selected',
}

export enum IdentifiedItemType {
  AttackWeapons = 'Attack Weapons',
  CasterWeapons = 'Caster Weapons',
  GemWeapons = 'Gem Weapons',
  Quivers = 'Quivers',
  LifeArmour = 'Life Armour',
  EnergyShieldArmour = 'Energy Shield Armour',
  Jewellery = 'Jewellery',
  Jewels = 'Jewels',
  TimeLostJewels = 'Time-Lost Jewels',
  AbyssJewels = 'Abyss Jewels',
  Custom = 'Custom',
}

export enum AttackWeaponsCategory {
  All = 'All',
  MeleePhysical = 'Melee Physical',
  MeleeElemental = 'Melee Elemental',
  RangedPhysical = 'Ranged Physical',
  RangedElemental = 'Ranged Elemental',
  None = 'None',
}

export enum CasterWeaponsCategory {
  All = 'All',
  Fire = 'Fire',
  Cold = 'Cold',
  Lightning = 'Lightning',
  Chaos = 'Chaos',
  Physical = 'Physical Caster',
  Minion = 'Minion',
  None = 'None',
}

export enum GemWeaponsCategory {
  All = 'All',
  Bows = 'Bows',
  Caster = 'Caster',
  Staves = 'Staves',
  None = 'None',
}

export enum QuiversCategory {
  All = 'All',
  PhysicalQuivers = 'Physical Quivers',
  ElementalQuivers = 'Elemental Quivers',
  DoT = 'DoT Quivers',
  None = 'None',
}

export enum LifeArmourCategory {
  All = 'All',
  LifeBoots = 'Life Boots',
  LifeHelmets = 'Life Helmets',
  LifeGloves = 'Life Gloves',
  LifeBodyArmours = 'Life Body Armours',
  LifeShields = 'Life Shields',
  None = 'None',
}

export enum EnergyShieldArmourCategory {
  All = 'All',
  EsBoots = 'ES Boots',
  EsHelmets = 'ES Helmets',
  EsGloves = 'ES Gloves',
  EsBodyArmours = 'ES Body Armours',
  EsShields = 'ES Shields',
  None = 'None',
}

export enum JewelleryCategory {
  All = 'All',
  Belts = 'Belts',
  MinionBelts = 'Minion Belts',
  CasterBelts = 'Caster Belts',
  AttackRings = 'Attack Rings',
  CasterRings = 'Caster Rings',
  MinionRings = 'Minion Rings',
  AttackAmulets = 'Attack Amulets',
  CasterAmulets = 'Caster Amulets',
  MinionAmulets = 'Minion Amulets',
  None = 'None',
}

export enum JewelsCategory {
  All = 'All',
  MeleeAttackJewels = 'Melee Jewels',
  RangedAttackJewels = 'Ranged Jewels',
  CasterJewels = 'Caster Jewels',
  MinionJewels = 'Minion Jewels',
  DotJewels = 'DoT Jewels',
  None = 'None',
}

export enum AbyssJewelsCategory {
  All = 'All',
  MeleeAttackAbyssJewels = 'Melee Abyss Jewels',
  RangedAttackAbyssJewels = 'Ranged Abyss Jewels',
  CasterAbyssJewels = 'Caster Abyss Jewels',
  MinionAbyssJewels = 'Minion Abyss Jewels',
  None = 'None',
}

export enum TimeLostJewelsCategory {
  All = 'All',
  MeleeAttackTimeLostJewels = 'Melee Time-Lost Jewels',
  RangedAttackTimeLostJewels = 'Ranged Time-Lost Jewels',
  CasterTimeLostJewels = 'Caster Time-Lost Jewels',
  MinionTimeLostJewels = 'Minion Time-Lost Jewels',
  None = 'None',
}

export type ModItemCategoryType = AttackWeaponsCategory | CasterWeaponsCategory | GemWeaponsCategory | QuiversCategory | LifeArmourCategory | EnergyShieldArmourCategory | JewelleryCategory | JewelsCategory | AbyssJewelsCategory | TimeLostJewelsCategory;

export const ITEM_CATEGORIES_POE1_ONLY: ModItemCategoryType[] = [
  QuiversCategory.DoT, QuiversCategory.ElementalQuivers,
  JewelsCategory.DotJewels,
  AttackWeaponsCategory.MeleeElemental, AttackWeaponsCategory.RangedElemental
];

export const ITEM_CATEGORIES_POE2_ONLY: ModItemCategoryType[] = [
  JewelleryCategory.MinionBelts, JewelleryCategory.MinionAmulets, JewelleryCategory.CasterBelts
];

export enum CustomModItemType {
  Any = 'Any',
  Weapon = 'Weapon',
  Armour = 'Armour',
  Jewellery = 'Jewellery',
  Jewel = 'Jewel',
  AbyssJewel = 'Abyss Jewel',
  TimeLostJewel = 'Time-Lost Jewel',
}

export enum ModDomain {
  Equipment = 'e',
  Jewel = 'j',
  AbyssJewel = 'a',
  TimeLostJewel = 't',
  ClusterJewel = 'c',
}

export enum WeaponType {
  All = 'All',
  Bows = 'Bows',
  Claws = 'Claws', // POE1
  Crossbows = 'Crossbows', // POE2
  Daggers = 'Daggers', // POE1
  Foci = 'Foci', // POE2
  OneHandSwords = 'One Hand Swords', // POE1
  OneHandAxes = 'One Hand Axes', // POE1
  OneHandMaces = 'One Hand Maces',
  Quivers = 'Quivers',
  Quarterstaves = 'Quarterstaves', // POE2
  RuneDaggers = 'Rune Daggers', // POE1
  Sceptres = 'Sceptres',
  Spears = 'Spears', // POE2
  Talismans = 'Talismans', // POE2
  Staves = 'Staves',
  ThrustingOneHandSwords = 'Thrusting One Hand Swords', // POE1
  TwoHandAxes = 'Two Hand Axes', // POE1
  TwoHandMaces = 'Two Hand Maces',
  TwoHandSwords = 'Two Hand Swords', // POE1
  Wands = 'Wands',
  Warstaves = 'Warstaves' // POE1
}

export enum ArmourType {
  All = "All",
  BodyArmours = "Body Armours",
  Helmets = "Helmets",
  Gloves = "Gloves",
  Boots = "Boots",
  Shields = "Shields",
  Bucklers = "Bucklers" // POE2
}

export enum FlaskType {
  All = 'All',
  LifeFlasks = 'Life Flasks',
  ManaFlasks = 'Mana Flasks',
  HybridFlasks = 'Hybrid Flasks', // POE1
  UtilityFlasks = 'Utility Flasks', // POE1
  Tinctures = 'Tinctures', // POE1
}

export enum JewelleryType {
  All = 'All',
  Rings = 'Rings',
  Amulets = 'Amulets',
  Belts = 'Belts',
  Talismans = 'Talismans', // POE1
}

export enum BaseTypeTier {
  Master = "Master",
  Elite = "Elite",
  Expert = "Expert",
  Advanced = "Advanced",
  Basic = "Basic"
}

export enum GearBaseTypeMode {
  Tier = "Tier",
  Specific = "Specific",
}

export enum SocketedItemType {
  All = "All",
  TwoOrMoreSockets = "TwoOrMoreSockets"
}

export enum GearSizeType {
  All = "All",
  MediumOnly = "MediumOnly",
  SmallOnly = "SmallOnly",
  TwoByTwoOnly = "TwoByTwoOnly",
  JewelleryOnly = "JewelleryOnly"
}

export enum VendoringGearType {
  ShowDefault = "ShowDefault",
  ShowStyled = "ShowStyled",
  ShowTransparent = "ShowTransparent",
  PreventTransparentHidden = "PreventTransparentHidden",
  ShowNormalHighlightLevelingRares = "ShowNormalHighlightLevelingRares",
}

export enum JewelType {
  All = 'All',

  Ruby = 'Ruby',// POE2
  Emerald = 'Emerald',// POE2
  Sapphire = 'Sapphire',// POE2
  Diamond = 'Diamond',// POE2

  Crimson = 'Crimson Jewel',// POE1
  Viridian = 'Viridian Jewel',// POE1
  Cobalt = 'Cobalt Jewel',// POE1

  MurderousEye = 'Murderous Eye Jewel',// POE1
  SearchingEye = 'Searching Eye Jewel',// POE1
  HypnoticEye = 'Hypnotic Eye Jewel',// POE1
  GhastlyEye = 'Ghastly Eye Jewel',// POE1

  LargeCluster = 'Large Cluster Jewel',// POE1
  MediumCluster = 'Medium Cluster Jewel',// POE1
  SmallCluster = 'Small Cluster Jewel'// POE1
}

export enum Comparator {
  GreaterThanOrEqual = '>=',
  LessThanOrEqual = '<=',
  Equal = '=='
}

export enum YesNoAny {
  Any = 'Any',
  Yes = 'Yes',
  No = 'No'
}

export enum MinimapIconSize {
  Large = 0,
  Medium = 1,
  Small = 2
}

export enum LabelSize {
  Smallest = 21,
  Smaller = 25,
  Small = 29,
  Normal = 33,
  Large = 37,
  Larger = 41,
  Largest = 45
}

export type DefaultLabelSize = 'smallest' | 'smaller' | 'small' | 'default' | 'large' | 'larger' | 'largest';

export const DEFAULT_LABEL_SIZE_OPTIONS: DefaultLabelSize[] = ['smallest', 'smaller', 'small', 'default', 'large', 'larger', 'largest'];

export const DEFAULT_LABEL_SIZE_LABELS: Record<DefaultLabelSize, string> = {
  smallest: 'Smallest',
  smaller: 'Smaller',
  small: 'Small',
  default: 'Default',
  large: 'Large',
  larger: 'Larger',
  largest: 'Largest',
};

export const DEFAULT_LABEL_SIZE_FACTORS: Record<DefaultLabelSize, number> = {
  smallest: 0.70,
  smaller: 0.80,
  small: 0.90,
  default: 1.00,
  large: 1.10,
  larger: 1.20,
  largest: 1.30,
};

export function scaleLabelSize(size: number, defaultLabelSize: DefaultLabelSize): number {
  const factor = DEFAULT_LABEL_SIZE_FACTORS[defaultLabelSize];
  return Math.min(45, Math.max(17, Math.round(size * factor)));
}

export enum MinimapIconShape {
  Circle = 'Circle',
  Diamond = 'Diamond',
  Hexagon = 'Hexagon',
  Square = 'Square',
  Star = 'Star',
  Triangle = 'Triangle',
  Cross = 'Cross',
  Moon = 'Moon',
  Raindrop = 'Raindrop',
  Kite = 'Kite',
  Pentagon = 'Pentagon',
  UpsideDownHouse = 'UpsideDownHouse'
}

export enum Color {
  Red = 'Red',
  Green = 'Green',
  Blue = 'Blue',
  Brown = 'Brown',
  White = 'White',
  Yellow = 'Yellow',
  Cyan = 'Cyan',
  Grey = 'Grey',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple'
}

export enum Rarity {
  Normal = 'Normal',
  Magic = 'Magic',
  Rare = 'Rare',
  Unique = 'Unique'
}

export enum DisplayType {
  Tier = 'Tier',
  DivCardTier = 'DivCardTier',
  EquipmentTier = 'EquipmentTier',
  Custom = 'Custom',
  ItemTypeOverrides = 'ItemTypeOverrides'
}

export enum EquipmentTierType {
  MyEquipment = 'MyEquipment',
  UnidentifiedEquipment = 'UnidentifiedEquipment',
  IdentifiedEquipment = 'IdentifiedEquipment',
  CraftingBaseEquipment = 'CraftingBaseEquipment',
  LevelingEquipment = 'LevelingEquipment',
  SalvagingEquipment = 'SalvagingEquipment',
  Item = 'Item',
  Map = 'Map',
  Gem = 'Gem',
  Gold = 'Gold',
  Verisium = 'Verisium',
}

export enum RuneType {
  Lesser = "Lesser",
  Normal = "Normal",
  Greater = "Greater",
  Special = "Special"
}

export enum WaystoneFilterType {
  StaticDefault = "StaticDefault",
  StaticStrict = "StaticStrict",
  Dynamic = "Dynamic"
}

export enum MapType {
  All = 'All',
  LowTierInfluenced = 'LowTierInfluenced',
  LowTierMemoryInfluenced = 'LowTierMemoryInfluenced',
  LowTierMemoryBlighted = 'LowTierMemoryBlighted',
  LowTierDelirium = 'LowTierDelirium',
  BlightRavaged = 'BlightRavaged',
  CorruptedBlightRavaged = 'CorruptedBlightRavaged',
  T16Normal = 'T16Normal',
  T16EightMod = 'T16EightMod',
  T16Blighted = 'T16Blighted',
  T16Influenced = 'T16Influenced',
  T16MemoryInfluenced = 'T16MemoryInfluenced',
  T16Delirium = 'T16Delirium',
  Nightmare = 'Nightmare',
}

export enum SkillGemFilterType {
  StaticStrict = "StaticStrict",
  Dynamic = "Dynamic"
}

export enum EldritchItemType {
  All = 'All',
  SearingExarch = 'SearingExarch',
  EaterOfWorlds = 'EaterOfWorlds'
}

export type CurrencyTieringMode = 'Early' | 'Normal' | 'Strict' | 'VeryStrict' | 'Custom';
export type CurrencyTypeSelectionMode = 'All' | 'Common' | 'Droppable' | 'Custom';
export type UniquesTieringMode = 'Normal' | 'Strict' | 'VeryStrict' | 'Custom';
export type EquipmentTieringMode = 'Subtle' | 'Tiered';
export type ClusterJewelTieringMode = 'Normal' | 'Strict' | 'Custom';

export type RuleListType = 'weapon' | 'armour' | 'jewellery' | 'jewel' | 'flask' | 'custom' | 'cosmetic';

export enum EndgameContent {
  // Common
  Abyss = "Abyss",
  Breach = "Breach",
  Delirium = "Delirium",
  Expedition = "Expedition",
  Essence = "Essence",
  Ritual = "Ritual",
  Temple = "Temple",
  UniqueMap = "Unique Map",
  Crafting = "Crafting",
  // POE2 Only
  ChaosTrial = "Chaos Trial",
  SekhemasTrial = "Sekhemas Trial",
  Monolith = "Monolith",
  Origin = "Origin",
  CorruptedNexus = "Corrupted Nexus",
  AzmeriSpirit = "Azmeri Spirit",
  // POE1 Only
  Heist = "Heist",
  Blight = "Blight",
  Legion = "Legion",
  Synthesis = "Synthesis",
  Ultimatum = "Ultimatum",
  Betrayal = "Betrayal",
  Labyrinth = "Labyrinth",
  Delve = "Delve",
  // Harvest = "Harvest",
  Sanctum = "Sanctum",
  Settlers = "Settlers",
  ReflectingMist = "Reflecting Mist",
  Mirage = "Mirage",
  Bestiary = "Bestiary",
  // Bosses
  Conquerors = "Conquerors",
  EldritchHorrors = "Eldritch Horrors",
  MemoryGuardians = "Memory Guardians",
  Shaper = "Shaper",
  Elder = "Elder",
  Maven = "Maven",
}

export const NonSelectableEndgameTypes: EndgameContent[] = [
  EndgameContent.UniqueMap,
  EndgameContent.Crafting,
  EndgameContent.CorruptedNexus,
];

export const ENDGAME_ALL_LABEL = 'Any endgame content';

export const EndgameContentIconMap: Record<EndgameContent, string> = {
  // Common
  [EndgameContent.Abyss]: "/img/icons/abyss.png",
  [EndgameContent.Breach]: "/img/icons/breach.png",
  [EndgameContent.Delirium]: "/img/icons/delirium.png",
  [EndgameContent.Expedition]: "/img/icons/expedition.png",
  [EndgameContent.Essence]: "/img/icons/essence.png",
  [EndgameContent.Ritual]: "/img/icons/ritual.png",
  [EndgameContent.Temple]: "/img/icons/temple.png",
  [EndgameContent.UniqueMap]: "/img/icons/uniquemap.png",
  [EndgameContent.Crafting]: "/img/icons/hideout.png",
  // POE2 Only
  [EndgameContent.ChaosTrial]: "/img/icons/chaos.png",
  [EndgameContent.SekhemasTrial]: "/img/icons/sekhemas.png",
  [EndgameContent.Monolith]: "/img/icons/monolith.png",
  [EndgameContent.Origin]: "/img/icons/origin.png",
  [EndgameContent.CorruptedNexus]: "/img/icons/corruption.png",
  [EndgameContent.AzmeriSpirit]: "/img/icons/azmeri.png",
  // POE1 Only
  [EndgameContent.Heist]: "/img/icons/heist.png",
  [EndgameContent.Blight]: "/img/icons/blight.png",
  [EndgameContent.Legion]: "/img/icons/legion.png",
  [EndgameContent.Synthesis]: "/img/icons/synthesis.png",
  [EndgameContent.Ultimatum]: "/img/icons/ritual.png",
  [EndgameContent.Betrayal]: "/img/icons/betrayal.png",
  [EndgameContent.Labyrinth]: "/img/icons/labyrinth.png",
  [EndgameContent.Delve]: "/img/icons/delve.png",
  // [EndgameContent.Harvest]: "/img/icons/harvest.png",
  [EndgameContent.Sanctum]: "/img/icons/sanctum.png",
  [EndgameContent.Settlers]: "/img/icons/settlers.png",
  [EndgameContent.ReflectingMist]: "/img/icons/reflecting-myst.png",
  [EndgameContent.Mirage]: "/img/icons/mirage.png",
  [EndgameContent.Bestiary]: "/img/icons/bestiary.png",
  // Bosses
  [EndgameContent.Conquerors]: "/img/icons/conquerors.png",
  [EndgameContent.EldritchHorrors]: "/img/icons/eldritch.png",
  [EndgameContent.MemoryGuardians]: "/img/icons/memory.png",
  [EndgameContent.Shaper]: "/img/icons/shaper.png",
  [EndgameContent.Elder]: "/img/icons/elder.png",
  [EndgameContent.Maven]: "/img/icons/maven.png",
};

export const EndgameContentLabelMap: Record<EndgameContent, string> = {
  // Common
  [EndgameContent.Abyss]: "Abyss",
  [EndgameContent.Breach]: "Breach",
  [EndgameContent.Delirium]: "Delirium",
  [EndgameContent.Expedition]: "Expedition",
  [EndgameContent.Essence]: "Essences",
  [EndgameContent.Ritual]: "Ritual",
  [EndgameContent.Temple]: "Atziri's Temple",
  [EndgameContent.UniqueMap]: "Unique Maps",
  [EndgameContent.Crafting]: "Crafting Bases",
  // POE2 Only
  [EndgameContent.ChaosTrial]: "Trial of Chaos",
  [EndgameContent.SekhemasTrial]: "Trial of the Sekhemas",
  [EndgameContent.Monolith]: "Monolith",
  [EndgameContent.Origin]: "Origins",
  [EndgameContent.CorruptedNexus]: "Corrupted Nexus",
  [EndgameContent.AzmeriSpirit]: "Azmeri Spirits",
  // POE1 Only
  [EndgameContent.Heist]: "Heist",
  [EndgameContent.Blight]: "Blight",
  [EndgameContent.Legion]: "Legion",
  [EndgameContent.Synthesis]: "Synthesis",
  [EndgameContent.Ultimatum]: "Ultimatum",
  [EndgameContent.Betrayal]: "Betrayal",
  [EndgameContent.Labyrinth]: "The Labyrinth",
  [EndgameContent.Delve]: "Delve",
  // [EndgameContent.Harvest]: "Harvest", // TODO
  [EndgameContent.Sanctum]: "The Forbidden Sanctum",
  [EndgameContent.Settlers]: "Settlers",
  [EndgameContent.ReflectingMist]: "Reflecting Mist",
  [EndgameContent.Mirage]: "Mirage",
  [EndgameContent.Bestiary]: "Bestiary",
  // Bosses
  [EndgameContent.Conquerors]: "Conquerors",
  [EndgameContent.EldritchHorrors]: "Eldritch Horrors",
  [EndgameContent.MemoryGuardians]: "Memory Guardians",
  [EndgameContent.Shaper]: "Shaper",
  [EndgameContent.Elder]: "Elder",
  [EndgameContent.Maven]: "Maven",
};

export function getEndgameContentIcon(content: EndgameContent): string {
  return EndgameContentIconMap[content];
}
